import { atualizarVisibilidadeDosCamposAdicionais, atualizarValorCampoAdicionalPorId, atualizarValorCampoAdicionalPorSigla } from "../dadosPedido/helper";
import { compatibilizarPreenchimentoDoTipoVinculo } from "../vinculos/helper";
import isNil from "lodash/isNil";

export const iniciarEtapa = etapa => ({
  type: 'REQUERIMENTO_ONBOARDING_INICIAR_ETAPA',
  payload: etapa
})

export const setPreviewPage = page => ({
  type: 'REQUERIMENTO_ONBOARDING_PREVIEW_PAGE',
  payload: page
})

export const concluirEtapa = (etapa, concluido) => {
  return {
    type: 'REQUERIMENTO_ONBOARDING_CONCLUIR_ETAPA',
    payload: { etapa, concluido }
  };
};

export const setRequerimento = requerimentoTO => {
  return (dispatch, getState) => {
    const requerimentoTOLocal =
      getState().requerimentos.onboarding.requerimentoTO;
    requerimentoTO.contato = requerimentoTOLocal.contato;
    requerimentoTO.etapas = requerimentoTOLocal.etapas;
    requerimentoTO.dadosAdicionais = requerimentoTO.dadosAdicionais;
    atualizarVisibilidadeDosCamposAdicionais(requerimentoTO.dadosAdicionais);
    requerimentoTO.vinculos = requerimentoTOLocal.vinculos;
    return dispatch(setRequerimentoInicial(requerimentoTO));
  };
}

export const setRequerimentoZerar = () => ({
  type: 'REQUERIMENTO_SET_REQUERIMENTO_ZERAR'
})

export const setRequerimentoInicial = requerimentoTO => {
  return {
    type: 'REQUERIMENTO_SET_REQUERIMENTO_INIT',
    payload: requerimentoTO
  }
}

export const setRequerimentoTO = (path, value) => ({
  type: 'REQUERIMENTO_SET_REQUERIMENTO_TO',
  payload: {
    path,
    value,
  }
})

export const alterCampoAdicional = (value, campoId) => ({
  type: 'REQUERIMENTO_ALTERAR_CAMPO_ADICIONAL',
  payload: {
    path: 'requerimentoTO.dadosAdicionais',
    value,
    campoId
  }
})

export const alterCampoAdicionalPorSigla = (sigla, { valor, preenchidoPorIntegracao, visivel }) => {
  return (dispatch, getState) => {
    const campos = getState().requerimentos.onboarding.requerimentoTO.dadosAdicionais;
    let campoModificado = campos.find((campo) => campo.sigla === sigla);
    if (campoModificado) {
        campoModificado = {
          ...campoModificado,
          valorComMascara: valor,
          valor: valor,
          preenchidoPorIntegracao: isNil(preenchidoPorIntegracao) ? campoModificado.preenchidoPorIntegracao : preenchidoPorIntegracao,
          visivel: isNil(visivel) ? campoModificado.visivel : visivel
        };
    }
    const listaModificada = gerarListaDeCamposAposAlteracaoDoCampo(campoModificado, campos);

    return dispatch({
      type: "REQUERIMENTO_ALTERAR_LISTA_CAMPO_ADICIONAL",
      payload: listaModificada,
    });
  }
}

export const limparCamposPorSiglas = (siglas = []) => {
  return (dispatch, getState) => {
    const campos = getState().requerimentos.onboarding.requerimentoTO.dadosAdicionais;
    let listaModificada = [].concat(campos);
    siglas.forEach((sigla) => {
      let campoModificado = listaModificada.find((campo) => campo.sigla === sigla);
      if (campoModificado) {
          campoModificado = {
            ...campoModificado,
            valorComMascara: null,
            valor: null
          };
      }
    });
    atualizarVisibilidadeDosCamposAdicionais(listaModificada);

    return dispatch({
      type: "REQUERIMENTO_ALTERAR_LISTA_CAMPO_ADICIONAL",
      payload: listaModificada,
    });
  }
}

export const alterCampoAdicionalDeIntegracaoPorSigla = (sigla, value) => {
  return (dispatch) => {
    return dispatch(alterCampoAdicionalPorSigla(sigla, { valor: value, preenchidoPorIntegracao: true }));
  }
}

export const alterVisibilidadeCampoAdicionalPorSigla = (sigla, visivel) => {
  return (dispatch, getState) => {
    const campos =
      getState().requerimentos.onboarding.requerimentoTO.dadosAdicionais;
    let campoModificado = campos.find((campo) => campo.sigla === sigla);
    if (campoModificado) {
      campoModificado.visivel = visivel;
    }
    const listaModificada = gerarListaDeCamposAposAlteracaoDoCampo(campoModificado, campos);

    return dispatch({
      type: "REQUERIMENTO_ALTERAR_LISTA_CAMPO_ADICIONAL",
      payload: listaModificada,
    });
  };
}

export const alterCampoAdicionalCombobox = (value, campoId) => {
  return (dispatch, getState) => {
    const campos =
      getState().requerimentos.onboarding.requerimentoTO.dadosAdicionais;
    const campoModificado = atualizarValorCampoAdicionalPorId(campos, campoId, value);
    const listaModificada = gerarListaDeCamposAposAlteracaoDoCampo(campoModificado, campos);

    return dispatch({
      type: "REQUERIMENTO_ALTERAR_LISTA_CAMPO_ADICIONAL",
      payload: listaModificada,
    });
  };
};

const gerarListaDeCamposAposAlteracaoDoCampo = (campoModificado, listaAtual) => {
  let listaModificada = [].concat(listaAtual);
  if (campoModificado) {
    listaModificada = listaAtual.map((campo) => {
      if (campo.id === campoModificado.id) {
        return {
          ...campoModificado,
        };
      }
      return campo;
    });
    atualizarVisibilidadeDosCamposAdicionais(listaModificada);
  }
  return listaModificada;
}

export const alterarListaAnexosDoRequerimento = (anexos) => {
  return {
    type: 'REQUERIMENTO_ALTERAR_LISTA_ANEXOS',
    payload: anexos
  }
}

export const alterarListaVinculosDoRequerimento = (vinculos) => {
  const vinculosConvertidos = compatibilizarPreenchimentoDoTipoVinculo(vinculos);
  return {
    type: 'REQUERIMENTO_ALTERAR_LISTA_VINCULOS',
    payload: vinculosConvertidos
  }
}

export const adicionarVinculo = (vinculo) => {
  return {
    type: 'REQUERIMENTO_ADICIONAR_VINCULO',
    payload: vinculo
  }
}
